export const INTERACTION_KEYS = {
  all: ['interaction'] as const,
  cpt: (userid: string | number) => [...INTERACTION_KEYS.all, 'cpt', String(userid)] as const,
  times: (userid: string | number) => [...INTERACTION_KEYS.all, 'times', String(userid)] as const,
} as const;
